/* tslint:disable */
/* eslint-disable */
/* @relayHash 45862e617eab2786014098e37e070cb9 */

import { ConcreteRequest } from "relay-runtime";
export type ACCOUNT_TYPE = "STUDENT" | "TEACHER" | "%future added value";
export type UpdateAccountSettingsInput = {
    username?: string | null;
    email?: string | null;
    password?: string | null;
    oldPassword?: string | null;
    accountType?: ACCOUNT_TYPE | null;
    clientMutationId?: string | null;
};
export type UpdateAccountSettingsMutationVariables = {
    input: UpdateAccountSettingsInput;
};
export type UpdateAccountSettingsMutationResponse = {
    readonly updateAccountSettings: {
        readonly user: {
            readonly id: string;
            readonly username: string;
            readonly email: string | null;
        } | null;
    } | null;
};
export type UpdateAccountSettingsMutation = {
    readonly response: UpdateAccountSettingsMutationResponse;
    readonly variables: UpdateAccountSettingsMutationVariables;
};



/*
mutation UpdateAccountSettingsMutation(
  $input: UpdateAccountSettingsInput!
) {
  updateAccountSettings(input: $input) {
    user {
      id
      username
      email
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateAccountSettingsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateAccountSettings",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAccountSettingsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateAccountSettingsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateAccountSettingsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateAccountSettingsMutation",
    "id": null,
    "text": "mutation UpdateAccountSettingsMutation(\n  $input: UpdateAccountSettingsInput!\n) {\n  updateAccountSettings(input: $input) {\n    user {\n      id\n      username\n      email\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '1db691c091996bda02082382148f3e66';
export default node;
